import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.marza < 0) {
    toast.error('Marža ne može biti manja od 0.');
    return true;
  }
  if (
    formData.nabavnaCena &&
    (!formData.prodajnaCena || Number.isNaN(Number(formData.prodajnaCena)))
  ) {
    toast.error('Unesite prodajnu cenu');
    return true;
  }

  return false;
};
